import * as React from "react";
import { FormJSON } from "../form";
import { Dialog } from "../component/Dialog.jsx";
import { WidgetFrame } from "./WidgetFrame.jsx";
import * as cls from "./AddWidget.module.scss";
import svgAddWidget from "./AddWidget.svg";
// eslint-disable-next-line no-unused-vars
import { AddWidgetModel } from "./AddWidget.jsx";
export { AddWidgetView };
/**
 * Вид виджета добавления виджетов.
 * @param {Object} props - Атрибуты элемента.
 * @param {AddWidgetModel} props.model - Модель виджета.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function AddWidgetView({ model }) {
  const schema = model.getSchema();
  return (
    <WidgetFrame type={WidgetFrame.Type.NONE}>
      <a className={cls.add_widget} onClick={model.onClick}>
        <div className={cls.add_widget_button}>
          <img src={svgAddWidget} />
        </div>
        <div className={cls.add_widget_label}>
          <h2>Добавить виджет</h2>
          <p>Настраивайте вид интерфейса как вам удобно</p>
        </div>
      </a>
      <Dialog title={model.title} open={model.open} onClose={model.onClick}>
        <FormJSON schema={schema} />
      </Dialog>
    </WidgetFrame>
  );
}
